import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TRADING_NAV_ITEMS, isNavItemActive } from './trading-nav-items';
import ThemeToggle from './ThemeToggle';
import './MobileBottomNav.css';

const MORE_ITEMS = TRADING_NAV_ITEMS.filter(
  (item) => !['normal', 'cnc', 'sold', 'ledger'].includes(item.key)
);

const PRIMARY_ITEMS = [
  TRADING_NAV_ITEMS.find((i) => i.key === 'normal'),
  TRADING_NAV_ITEMS.find((i) => i.key === 'cnc'),
  TRADING_NAV_ITEMS.find((i) => i.key === 'sold'),
  TRADING_NAV_ITEMS.find((i) => i.key === 'ledger'),
  { path: '#more', label: 'More', icon: '☰', key: 'more' }
].filter(Boolean);

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const [moreOpen, setMoreOpen] = useState(false);

  useEffect(() => {
    setMoreOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!moreOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setMoreOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [moreOpen]);

  const moreActive = MORE_ITEMS.some((item) => isNavItemActive(pathname, item));

  return (
    <>
      {moreOpen && (
        <button
          type="button"
          className="mobile-more-backdrop"
          aria-label="Close menu"
          onClick={() => setMoreOpen(false)}
        />
      )}

      {moreOpen && (
        <div className="mobile-more-sheet" role="dialog" aria-label="More screens">
          <div className="mobile-more-handle" />
          <p className="mobile-more-title">More screens</p>
          <div className="mobile-more-theme">
            <ThemeToggle />
          </div>
          <div className="mobile-more-grid">
            {MORE_ITEMS.map((item) => (
              <Link
                key={item.key}
                to={item.path}
                className={`mobile-more-item${isNavItemActive(pathname, item) ? ' active' : ''}`}
                onClick={() => setMoreOpen(false)}
              >
                <span aria-hidden>{item.icon}</span>
                <strong>{item.label}</strong>
              </Link>
            ))}
          </div>
        </div>
      )}

      <nav className="mobile-bottom-nav" aria-label="Primary trading tabs">
        {PRIMARY_ITEMS.map((item) => {
          if (item.key === 'more') {
            return (
              <button
                key="more"
                type="button"
                className={`mobile-bottom-tab${moreOpen || moreActive ? ' active' : ''}`}
                onClick={() => setMoreOpen((v) => !v)}
                aria-expanded={moreOpen}
              >
                <span className="mobile-bottom-icon" aria-hidden>{item.icon}</span>
                <span className="mobile-bottom-label">{item.label}</span>
              </button>
            );
          }
          const active = isNavItemActive(pathname, item);
          return (
            <Link
              key={item.key}
              to={item.path}
              className={`mobile-bottom-tab${active ? ' active' : ''}${item.highlight ? ' highlight' : ''}`}
            >
              <span className="mobile-bottom-icon" aria-hidden>{item.icon}</span>
              <span className="mobile-bottom-label">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </>
  );
}
